<template>
    <span :class="badge.class">{{ badge.label }}</span>
</template>

<script>
const map = {
    1: {
        label: 'Онлайн',
        class: ['badge', 'badge-success']
    },
    2: {
        label: 'Офлайн',
        class: ['badge', 'badge-secondary']
    }
}

const fallback = {
    label: '—',
    class: ['text-muted']
}

export default {
    props: {
        state: {
            type: String | Number,
            default: null
        }
    },

    computed: {
        badge() {
            return map[this.state] || fallback
        }
    }
}
</script>
